import { asRecord, toNumber, toString } from '@sites/entity-migrator';

import type { LegacyGridEntity } from './types';
import type { GridDefaultV0 } from '../default/v0';

export const migrateLegacyDefaultToV0 = (input: LegacyGridEntity): GridDefaultV0 => {
    const legacy = asRecord(input) as LegacyGridEntity;
    const data = asRecord(legacy.data) as LegacyGridEntity['data'];
    const entityId = toString(legacy.id);

    const columnId = legacy.columnId;
    const tabId = legacy.tabId;
    const parentId = tabId ? toString(tabId) : toString(columnId);

    return {
        id: entityId,
        parentId: parentId,
        entityType: 'grid',
        entitySubType: 'default',
        children: legacy.widgets,
        props: {
            variant: input.variant,
            gapX: {
                desktop: {
                    value: toNumber(data.gapX),
                    unit: 'px',
                },
            },
            gapY: {
                desktop: {
                    value: toNumber(data.gapY),
                    unit: 'px',
                },
            },
            rowCellWidth: {
                desktop: data.rowCellWidth ?? [],
            },
        },
        version: 0,
        // Created before the field existed — when is not known.
        meta: { createdAt: null },
    };
};
